import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app_godown',
  templateUrl: './Godown.component.html',
  styleUrls: ['./Godown.component.css']
})
export class GodownComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Godown/Godown.component.ts